import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

const check = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`;

const Valid = styled(({
  X1, Y1, X2, Y2, X3, Y3, L,
  className,
  color = theme.colors.create || '#000',
  size = 24,
  strokeWidth = 3,
  ...props
}) => (
  <svg
    className={className}
    width={size + strokeWidth}
    height={size + strokeWidth}
    viewBox={`0 0 ${size + strokeWidth} ${size + strokeWidth}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  >
    <path
      id="path"
      d={`M${X1} ${Y1} L${X2} ${Y2} L${X3} ${Y3}`}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeDasharray={L}
      strokeDashoffset={L}
    />
  </svg>
))`
  #path {
    animation: ${check} ${({ speed = 500 }) => speed}ms ease forwards;
  }
`;

const ValidIcon = ({
  color,
  size,
  strokeWidth,
  ...props
}) => {
  const X1 = strokeWidth / 2;
  const Y1 = size / 2;
  const X2 = (size / 8) * 3;
  const Y2 = (size / 5) * 4;
  const X3 = size - (strokeWidth / 2);
  const Y3 = (size / 5) * 1;
  const D1 = Math.sqrt(((X2 - X1) ** 2) + ((Y2 - Y1) ** 2));
  const D2 = Math.sqrt(((X3 - X2) ** 2) + ((Y3 - Y2) ** 2));
  const L = D1 + D2; // length of path
  return (
    <Valid
      {...{
        X1,
        Y1,
        X2,
        Y2,
        X3,
        Y3,
        L,
        color,
        size,
        strokeWidth,
        ...props,
      }}
    />
  );
};
ValidIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
};
ValidIcon.defaultProps = {
  color: theme.colors.create || '#000',
  size: 24,
  strokeWidth: 3,
};

export default fn(__filename, ValidIcon);



// WEBPACK FOOTER //
// ./src/components/icons/ValidIcon.js